import React, { useEffect } from "react";

import { Container } from "@mui/material";
import { useParams } from "next/navigation";
import { preload } from "react-dom";

import { GlobalPathParams } from "~/app/[locale]/types";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { useAzureConfigurator } from "~/services/azure-configurator/use-azure-configurator";
import { Logger } from "~/utils/logger";

const setupUgcStoryStreamScript = (scriptSrc: string) => {
  const script = document.createElement("script");
  script.src = scriptSrc;
  script.id = "ugc-story-stream";
  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
};

export const UgcStoryStream = () => {
  const { locale } = useParams<GlobalPathParams>();
  const { appConfig } = useAzureConfigurator(locale);
  const scriptSrc = appConfig?.ugcStoryStream?.script;

  if (scriptSrc?.length) {
    preload(scriptSrc, { as: "script" });
  }

  useEffect(() => {
    if (!scriptSrc?.length) {
      Logger.getLogger().warn(
        "appConfig.ugcStoryStream.script is not defined in the config," +
          "but the component is rendered.",
      );

      return;
    }

    return setupUgcStoryStreamScript(scriptSrc);
  }, [scriptSrc]);

  return (
    <Container {...getTestAutomationProps("ugc-story-stream")}>
      <div id="stry-wrapper" />
    </Container>
  );
};
